const map = {
	"./Arrow.webp": 6973,
	"./Blackhole.webp": 8321,
	"./Fire.png": 7118,
	"./LilliaP.webp": 5259,
	"./Mine.webp": 6027,
	"./MoonThrow.jpg": 1229,
	"./Orbital.webp": 3161,
	"./ReindeerIcon.png": 9643,
	"./Shotgun.webp": 198,
	"./Skull.png": 495,
	"./Trap.png": 5479,
	"./earth.png": 7092,
	"./horse.png": 1871,
	"./lilliaIcon.webp": 8740,
	"./mooseIcon.png": 5700
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4960;